import Contact from '../features/contact/layouts/contact';

export default function ContactoPage() {
    return <Contact />;
}
